import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import Config from "Config";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import React, { useEffect, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { send } from "../../SendRequest";
import {
    getFormTitleParam,
    isNotEmpty,
    isObjectEmpty,
    isObjectNotEmpty,
} from "../../Utils";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomSelect from "../../inputComponent/CustomSelect/CustomSelect";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getFormTitleParamList } from "../../redux/selector";
import AlertDialog from "../AlertDialog/AlertDialog";
import FormBox from "../FormBox/FormBox";
import EmailTemplate from "./EmailTemplate";
import ParameterTemplate from "./ParameterTemplate";
import ParameterTemplate100 from "./ParameterTemplate100";
import ParameterTemplate101 from "./ParameterTemplate101";
import ParameterTemplate102 from "./ParameterTemplate102";
const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    container: {
        maxHeight: 250,
    },
    tableRow: {
        height: 15,
    },
    tableCell: {
        height: 10,
    },
    reminderBox: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 100px 0px 20px",
    },
    reminderBoxMobile: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 20px 0px 20px",
    },
    main: {
        flex: 1,
    },
    schoolBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    courseBox: {},
    courseItemBox: {
        background: "#ccc",
        margin: "5px 0",
    },
    cccLink: {
        textDecoration: "none!important",
    },
    switchSty: {
        "& .Mui-checked ": {
            color: "#46a35f !important",
        },
    },
    disable: {
        pointerEvents: "none",
        "& #completedSavedYears": {
            color: `rgba(${0}, ${0}, ${0}, ${0.58})`,
        },
        "& .MuiTypography-root MuiTypography-body1 MuiTypography-colorTextSecondary":
            {
                position: "absolute",
                right: "100px",
            },
    },
});

function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
}

/////Global/////

function ParameterPage() {
    const [defaultValues, setDefaultValues] = useState({});
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    const formTitleParam = useSelector(getFormTitleParamList());

    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const [saveFail, setSaveFail] = useState(false);
    const [differenceJobsText, setDifferenceJobsText] = useState("");
    const [differenceJobsDialog, setDifferenceJobsDialog] = useState(false);
    const [differenceJobsSubmitData, setDifferenceJobsSubmitData] = useState(
        {}
    );
    const handleSavedClose = () => {
        setIsSavedOpen(false);
    };

    function SavedDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    const [isDuplicatedMsg, setIsDuplicatedMsg] = useState(false);
    const handleConfirm = () => {
        setIsDuplicatedMsg(false);
    };
    // Part1: choose user-responsible forms

    const {
        register,
        unregister,
        handleSubmit,
        control,
        formState,
        clearErrors,
        reset,
        watch,
        getValues,
        setValue,
        trigger,
    } = useForm({
        defaultValues,
        mode: "onBlur",
        // shouldUnregister: false,
        // criteriaMode: "all",
    });

    const {
        fields: emailContentFields,
        append: emailContentAppend,
        remove: emailContentRemove,
    } = useFieldArray({
        control,
        name: "emailContent",
    });

    const {
        fields: replySlipFields,
        append: replySlipAppend,
        remove: replySlipRemove,
    } = useFieldArray({
        control,
        name: "replySlipMsgs",
    });

    //Part3:Reply Slip

    const [selectedForm, setForm] = useState(0);
    const [formList, setInitialFormList] = useState([]);
    let destinationObj = {};
    const [dataList, setDataList] = useState(destinationObj);
    const [schoolOption, setSchoolOption] = useState({});
    const [reviewerList, setReviewerList] = useState([]);
    const [schoolList, setSchoolList] = useState([]);

    const dispatch = useDispatch();
    const initialDefaultValues = {};
    const [layerNum, setLayerNum] = useState({});
    function getLayerPerForm() {
        if (isObjectNotEmpty(layerNum)) {
            return layerNum[selectedForm];
        } else {
            return 0;
        }
    }

    useEffect(() => {
        try {
            const fetchFormList = async () => {
                const option = {
                    url: `${Config.CONTENT_PATH}/parameters/`,
                };
                const res = await dispatch(send("PARAMETER_PAGE", option));
                try {
                    const data = await res.json();
                    setInitialFormList(data.userFormList);
                    setForm(data.userFormList[0]);
                    // console.log("data:" + JSON.stringify(data.userFormList));
                } catch (error) {
                    console.error(error);
                }
            };
            fetchFormList();
            const option = {
                url: `${Config.CONTENT_PATH}/form/getFormLayer`,
            };
            dispatch(send("GET_FORM_LAYER", option))
                .then((response) => response.json())
                .then((result) => {
                    setLayerNum(result);
                    // console.log("testLayers", result);
                })
                .catch((error) => console.log("fetch error", error));
        } catch (error) {
            console.error(error);
        }
    }, []);

    function hasDuplicates(array) {
        return new Set(array.map((v) => v.value)).size !== array.length;
    }

    useEffect(() => {
        for (var member in defaultValues) delete defaultValues[member];
        replySlipRemove();
        if (isObjectEmpty(defaultValues) && selectedForm != 0) {
            const option = {
                url: `${Config.CONTENT_PATH}/parameters/form/${selectedForm}`,
            };
            dispatch(send("FORM_PARAMETER", option))
                .then((res) => res.json())
                .then((data) => {
                    setDataList(data);
                    Object.entries(data.parameter).map((item) => {
                        if (handleParameter(item) && selectedForm !== 41) {
                            initialDefaultValues[item[0]] = JSON.parse(item[1]);
                        } else {
                            initialDefaultValues[item[0]] = item[1];
                        }
                    });

                    if (selectedForm == "41") {
                        let data41 = handleForm041Data(data.parameter);
                        setSchoolOption(data41);
                        if (isNotEmpty(data41)) {
                            initialDefaultValues["schoolOption"] = data41;
                        }
                    }

                    if (selectedForm == "106") {
                        const trcNameOption = data.parameter.trcNameOption;
                        if (trcNameOption) {
                            try {
                                const parsedTrcOption =
                                    JSON.parse(trcNameOption);

                                initialDefaultValues["trcNameOption"] =
                                    parsedTrcOption;
                            } catch (error) {
                                console.error(
                                    "Error parsing trcNameOption:",
                                    error
                                );
                            }
                        }

                        const excludedScrnList =
                            data.parameter.excludedScrnList;
                        if (excludedScrnList) {
                            try {
                                const parsedExcludedList =
                                    JSON.parse(excludedScrnList);
                                initialDefaultValues["excludedScrnList"] =
                                    parsedExcludedList;
                            } catch (error) {
                                console.error(
                                    "Error parsing excludedScrnList:",
                                    error
                                );
                            }
                        }
                    }

                    initialDefaultValues[`completedSavedYears`] =
                        data.reminder.completedSavedYears;
                    initialDefaultValues[`receivedPendingDays`] =
                        data.reminder.receivedPendingDays;
                    initialDefaultValues[`analystReportFlag`] =
                        data.reminder.analystReportFlag;
                    initialDefaultValues[`completedSavedYearsNoti`] =
                        data.reminder.completedSavedYearsNoti;
                    initialDefaultValues[`completedSavedYearsNotiChoice`] =
                        data.reminder.completedSavedYearsNotiChoice;
                    initialDefaultValues[`hkYearReminderFlag`] =
                        data.reminder.hkYearReminderFlag;
                    initialDefaultValues[`actionReminderFlag`] =
                        data.reminder.actionReminderFlag;
                    initialDefaultValues[`receivedPendingDaysChoice`] =
                        data.reminder.receivedPendingDaysChoice;
                    initialDefaultValues[`emailContent`] = data.emailContent;
                    initialDefaultValues[`replySlipMsgs`] = data.replySlipMsgs;
                    initialDefaultValues[`readOnlyApprover`] =
                        data.readOnly.readOnlyApprover;
                    initialDefaultValues[`readOnlySecondApprover`] =
                        data.readOnly.readOnlySecondApprover;
                    initialDefaultValues[`readOnlyThirdApprover`] =
                        data.readOnly.readOnlyThirdApprover;
                    initialDefaultValues[`readOnlyFourthApprover`] =
                        data.readOnly.readOnlyFourthApprover;
                    initialDefaultValues[`readOnlyEdbReviewer`] =
                        data.readOnly.readOnlyEdbReviewer;
                    setDefaultValues(initialDefaultValues);
                    reset(initialDefaultValues);
                });
        }
        if (selectedForm === 101) {
            const option = {
                url: `${Config.CONTENT_PATH}/users/reviewers/101/R`,
            };
            dispatch(send("GET_REVIEWER", option))
                .then((response) => response.json())
                .then((result) => {
                    if (result?.code === "0" && result?.success === true) {
                        setReviewerList(result?.data || []);
                    } else {
                        setReviewerList([]);
                    }
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                });
        }

        if (selectedForm === 106) {
            console.log("Calling API for form106 schools");
            const schoolOption = {
                url: `${Config.CONTENT_PATH}/clo/getAllForm106School`,
            };
            dispatch(send("GET_ALL_FORM106_SCHOOL", schoolOption))
                .then((response) => {
                    console.log("API response received", response);
                    return response.json();
                })
                .then((result) => {
                    console.log("API result parsed", result);
                    if (result?.code === "0" && result?.success === true) {
                        setSchoolList(result?.data || []);
                        console.log("School list set", result?.data);
                    } else {
                        setSchoolList([]);
                        console.log("No school data or error");
                    }
                })
                .catch((error) => {
                    console.log("fetch school list error: ", error);
                    setSchoolList([]);
                });
        } else {
            setSchoolList([]);
            console.log("Cleared school list for form", selectedForm);
        }
    }, [selectedForm]);

    // console.log("formList:" + formList);
    // console.log("selectedForm:" + selectedForm);

    const errors = formState.errors;
    console.log("errors----", errors);
    const onSubmit = (data) => {
        console.log(data);
        if (hasDuplicates(watch("replySlipMsgs"))) {
            setIsDuplicatedMsg(true);
        } else {
            data[`formId`] = selectedForm;
            const reminderTemp = {};
            Object.assign(reminderTemp, {
                completedSavedYears: `${getValues("completedSavedYears")}`,
                completedSavedYearsNoti: `${getValues(
                    "completedSavedYearsNoti"
                )}`,
                completedSavedYearsNotiChoice: `${getValues(
                    "completedSavedYearsNotiChoice"
                )}`,
                hkYearReminderFlag: `${getValues("hkYearReminderFlag")}`,
                actionReminderFlag: `${getValues("actionReminderFlag")}`,
                receivedPendingDays: `${getValues("receivedPendingDays")}`,
                analystReportFlag: `${getValues("analystReportFlag")}`,
                receivedPendingDaysChoice: `${getValues(
                    "receivedPendingDaysChoice"
                )}`,
            });
            data[`reminder`] = reminderTemp;
            const paramObj = {};
            if (selectedForm == "41") {
                data[`parameter`] = handleSubmitForm041Data();
            } else if (selectedForm == "101") {
                data[`parameter`] = handleSubmitForm101Data(data);
            } else if (selectedForm == "106") {
                const paramObj = { ...dataList.parameter };
                Object.entries(dataList.parameter).map((item) => {
                    if (item[0] === "trcNameOption") {
                        const trcObject = getValues("trcNameOption") || {};
                        paramObj[item[0]] = JSON.stringify(trcObject);
                    } else if (item[0] === "excludedScrnList") {
                        const excludedScrnList =
                            getValues("excludedScrnList") || [];
                        paramObj[item[0]] = JSON.stringify(excludedScrnList);
                    } else {
                        if (handleParameter(item)) {
                            paramObj[item[0]] = JSON.stringify(
                                getValues(item[0])
                            );
                        } else {
                            paramObj[item[0]] = `${getValues(item[0])}`;
                        }
                    }
                });

                data[`parameter`] = paramObj;
            } else {
                Object.entries(dataList.parameter).map((item) => {
                    if (handleParameter(item)) {
                        paramObj[item[0]] = JSON.stringify(getValues(item[0]));
                    } else {
                        paramObj[item[0]] = `${getValues(item[0])}`;
                    }
                });
                data[`parameter`] = paramObj;
            }

            const readOnlyTemp = {};
            Object.assign(readOnlyTemp, {
                readOnlyApprover: `${getValues("readOnlyApprover")}`,
                readOnlySecondApprover: `${getValues(
                    "readOnlySecondApprover"
                )}`,
                readOnlyThirdApprover: `${getValues("readOnlyThirdApprover")}`,
                readOnlyFourthApprover: `${getValues(
                    "readOnlyFourthApprover"
                )}`,
                readOnlyEdbReviewer: `${getValues("readOnlyEdbReviewer")}`,
            });
            data[`readOnly`] = readOnlyTemp;

            delete data.completedSavedYears;
            delete data.completedSavedYearsNoti;
            delete data.completedSavedYearsNotiChoice;
            delete data.hkYearReminderFlag;
            delete data.actionReminderFlag;
            delete data.receivedPendingDays;
            delete data.analystReportFlag;
            delete data.receivedPendingDaysChoice;
            Object.entries(dataList.parameter).map((item) => {
                delete data[item[0]];
            });
            delete data.readOnlyApprover;
            delete data.readOnlySecondApprover;
            delete data.readOnlyThirdApprover;
            delete data.readOnlyFourthApprover;
            delete data.readOnlyEdbReviewer;

            console.log("submitted:" + data);
            if (selectedForm == "101") {
                var initJob = {};
                var submitJob = {};
                try {
                    initJob = JSON.parse(dataList?.parameter?.job);
                    submitJob = JSON.parse(data?.parameter?.job);
                } catch (error) {
                    initJob = dataList?.parameter?.job;
                    submitJob = data?.parameter?.job;
                }
                const differenceJob = initJob?.filter(
                    (job) =>
                        job?.isPublish === true &&
                        (!submitJob?.find(
                            (e) => e?.jobTitle === job?.jobTitle
                        ) ||
                            !isEqual(
                                job,
                                submitJob?.find(
                                    (e) => e?.jobTitle === job?.jobTitle
                                )
                            ))
                );
                if (isObjectNotEmpty(differenceJob)) {
                    var differenceJobText = "";
                    const optionsList = getValues(
                        `jobApplication${i18n.language?.toUpperCase()}`
                    );
                    const initJobOptions = optionsList?.jobOptions || {};

                    differenceJob.forEach((job) => {
                        differenceJobText +=
                            t("Form101.errorMsg.differentJob", {
                                differentJob: initJobOptions?.[job?.jobTitle],
                            }) + "<br/>";
                    });
                    setDifferenceJobsText(differenceJobText);
                    setDifferenceJobsDialog(true);
                    setDifferenceJobsSubmitData(data);
                    return false;
                }
            }
            const option = {
                url: `${Config.CONTENT_PATH}/parameters/form`,
                method: "POST",
                body: JSON.stringify(data),
            };
            dispatch(send("SUBMIT_PARAMS", option))
                .then((response) => response.json())
                .then((result) => {
                    if (isObjectNotEmpty(result)) {
                        setIsSavedOpen(true);
                    } else {
                        setSaveFail(true);
                    }
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                });
        }
    };

    //part5: Email template

    const handleAllRadioChange = (event, name) => {
        register(name, event.target.value);
    };

    const [roles, setRoles] = useState([
        "Applicant",
        "Approver",
        "Second Approver",
        "Third Approver",
        "Fourth Approver",
        "EDB Reviewer",
        "Return to Applicant",
        "Reject",
    ]);
    useEffect(() => {
        if (selectedForm === 98) {
            if (i18n.language == "tc") {
                setRoles([
                    "A-E部份申請人",
                    "A-E部份審核人",
                    "A-E部份教育局審核人",
                    "F部份申請人",
                    "F部份審核人",
                    "教育局審核人",
                    "退回給填表者",
                    "拒收",
                ]);
            } else if (i18n.language == "sc") {
                setRoles([
                    "A-E部份申请人",
                    "A-E部份审核人",
                    "A-E部份教育局审核人",
                    "F部份申请人",
                    "F部份审核人",
                    "教育局审核人",
                    "退回给填表者",
                    "拒收",
                ]);
            } else {
                setRoles([
                    "Applicant of Part A-E",
                    "Approver of Part A-E",
                    "EDB Reviewer of Part A-E",
                    "Applicant of Part F",
                    "Approver of Part F",
                    "EDB Reviewer",
                    "Return to Applicant",
                    "Reject",
                ]);
            }
        } else if (selectedForm === 100) {
            if (i18n.language == "tc") {
                setRoles([
                    "申請已收到",
                    "審批人",
                    "第二審批人",
                    "第三審批人",
                    "第四審批人",
                    "教育局已審核",
                    "申請已退回",
                    "申請已拒絕",
                ]);
            } else if (i18n.language == "sc") {
                setRoles([
                    "申请已收到",
                    "审批人",
                    "第二审批人",
                    "第三审批人",
                    "第四审批人",
                    "教育局已审核",
                    "申请已退回",
                    "申请已拒绝",
                ]);
            } else {
                setRoles([
                    "Application Received",
                    "Approver",
                    "Second Approver",
                    "Third Approver",
                    "Fourth Approver",
                    "EDB Reviewer reviewed application",
                    "Application Returned",
                    "Application Rejected",
                ]);
            }
        } else if (selectedForm === 102) {
            if (i18n.language == "tc") {
                setRoles([
                    "申請人",
                    "審批人",
                    "教育局審核人（接收）",
                    "第三審批人",
                    "第四審批人",
                    "教育局審核人（審核）",
                    "退回給填表者",
                    "拒收",
                ]);
            } else if (i18n.language == "sc") {
                setRoles([
                    "申请人",
                    "审批人",
                    "教育局审核人（接收）",
                    "第三审批人",
                    "第四审批人",
                    "教育局审核人（审核）",
                    "退回给填表者",
                    "拒收",
                ]);
            } else {
                setRoles([
                    "Applicant",
                    "Approver",
                    "EDB Reviewer (Receive)",
                    "Third Approver",
                    "Fourth Approver",
                    "EDB Reviewer (Approve)",
                    "Return to Applicant",
                    "Reject",
                ]);
            }
        } else if (selectedForm === 104) {
            if (i18n.language == "tc") {
                setRoles([
                    "申請人",
                    "第二申請人",
                    "校長",
                    "第三審批人",
                    "第四審批人",
                    "教育局已審核",
                    "申請已退回",
                    "申請已拒絕",
                ]);
            } else if (i18n.language == "sc") {
                setRoles([
                    "申请人",
                    "第二申请人",
                    "校长",
                    "第三审批人",
                    "第四审批人",
                    "教育局已审核",
                    "申请已退回",
                    "申请已拒绝",
                ]);
            } else {
                setRoles([
                    "Applicant",
                    "Second Applicant",
                    "School Principal",
                    "Third Approver",
                    "Fourth Approver",
                    "EDB Reviewer reviewed application",
                    "Application Returned",
                    "Application Rejected",
                ]);
            }
        } else {
            if (i18n.language == "tc") {
                setRoles([
                    "申請人",
                    "審批人",
                    "第二審批人",
                    "第三審批人",
                    "第四審批人",
                    "教育局審核人",
                    "退回給填表者",
                    "拒收",
                ]);
            } else if (i18n.language == "sc") {
                setRoles([
                    "申请人",
                    "审批人",
                    "第二审批人",
                    "第三审批人",
                    "第四审批人",
                    "教育局审核人",
                    "退回给填表者",
                    "拒收",
                ]);
            } else {
                setRoles([
                    "Applicant",
                    "Approver",
                    "Second Approver",
                    "Third Approver",
                    "Fourth Approver",
                    "EDB Reviewer",
                    "Return to Applicant",
                    "Reject",
                ]);
            }
        }
    }, [i18n.language, selectedForm]);

    // const urlLinkNRefNum =
    //     "Url link: ${url}\nReference Number: ${form_reference_no}\nStatus: ${status}";

    // handleParameter
    const handleParameter = (item) => {
        let value = "";
        try {
            value = JSON.parse(item[1]);
        } catch (error) {
            value = item[1];
        }
        let flag =
            Object.prototype.toString.call(value).indexOf("Object") > -1 ||
            Object.prototype.toString.call(value) === "[object Array]";
        return flag;
    };

    // remove object parameters
    const removeParamer = (fatherName, key) => {
        let data = cloneDeep(getValues(fatherName));

        if (Array.isArray(data)) {
            if (fatherName === "trcNameOption" && data.length <= 1) {
                return;
            }

            data.splice(parseInt(key), 1);
        } else {
            if (fatherName === "trcNameOption") {
                if (Object.keys(data).length <= 1) {
                    return;
                }
                delete data[key];
            } else {
                delete data[key];
            }
        }

        setValue(fatherName, data);
        let copyDataList = cloneDeep(dataList);
        copyDataList.parameter[fatherName] = JSON.stringify(data);
        setDataList(copyDataList);
    };

    // add object parameters
    const appendParamer = (fatherName, initialValue = "") => {
        let data = cloneDeep(getValues(fatherName));

        if (Array.isArray(data)) {
            data.push(initialValue);
        } else {
            if (fatherName === "trcNameOption") {
                const keys = Object.keys(data || {});
                const maxKey =
                    keys.length > 0
                        ? Math.max(
                              ...keys
                                  .map((k) => parseInt(k))
                                  .filter((k) => !isNaN(k))
                          )
                        : 0;
                const newKey = (maxKey + 1).toString();

                if (!data) {
                    data = {};
                }
                data[newKey] = initialValue;
            } else {
                let objKey = Object.keys(data);
                let paraKey = `${Number(Math.max(...objKey)) + 1}`;
                data[`${paraKey}`] = initialValue;
            }
        }

        setValue(fatherName, data);
        let copyDataList = cloneDeep(dataList);
        copyDataList.parameter[fatherName] = JSON.stringify(data);
        setDataList(copyDataList);
    };

    const sortSchoolArray = (data) => {
        let arrNumber = data
            .filter(
                (item) =>
                    !isNaN(parseInt(item.name.toString().trim().substring(0.3)))
            )
            .sort((a, b) => {
                return (
                    parseInt(a.name.trim().substring(0, 3)) -
                    parseInt(b.name.trim().substring(0, 3))
                );
            });

        let arrCharacter = data.filter((item) =>
            isNaN(parseInt(item.name.toString().trim().substring(0.3)))
        );
        return arrNumber.concat(arrCharacter);
    };

    const handleForm041Data = (paramters) => {
        let ccsSchool = JSON.parse(paramters?.ccsSchoolOption);
        let ccsCourse = JSON.parse(paramters?.ccsCourseOption);
        let ccwSchool = JSON.parse(paramters?.ccwSchoolOption);
        let ccwCourse = JSON.parse(paramters?.ccwCourseOption);
        let curParams = {};
        Object.entries(paramters).forEach((item) => {
            if (handleParameter(item)) {
                curParams.CCSSchool = schoolCourse(ccsSchool, ccsCourse);
                curParams.CCWSchool = schoolCourse(ccwSchool, ccwCourse);
            } else {
                curParams[item[0]] = item[1];
            }
        });

        // sort 學校
        curParams.CCSSchool = sortSchoolArray(curParams.CCSSchool);
        curParams.CCWSchool = sortSchoolArray(curParams.CCWSchool);
        // console.log("curParams----", curParams);
        return curParams;
    };

    const schoolCourse = (_school, _course) => {
        let dataArr = [];
        for (let key in _school) {
            let _json = {
                key: key,
                name: _school[key],
                course: [],
            };
            for (let i in _course[key]) {
                let item = _course[key][i];
                if (
                    Object.prototype.toString.call(item).indexOf("String") > -1
                ) {
                    _course[key][i] = [item];
                }
            }
            _json.course = _course[key];
            dataArr.push(_json);
        }
        return dataArr;
    };

    const removeSchool = (item, index) => {
        let newSchoolOption = cloneDeep(getValues("schoolOption"));
        newSchoolOption[item].splice(index, 1);
        setValue("schoolOption", newSchoolOption);
        setSchoolOption(newSchoolOption);
    };

    const removeCourse = (item, index, courseIndex) => {
        let newSchoolOption = cloneDeep(getValues("schoolOption"));
        delete newSchoolOption[item][index].course[courseIndex];
        setValue("schoolOption", newSchoolOption);
        setSchoolOption(newSchoolOption);
    };

    const getSchoolMaxKey = (data) => {
        let keyArr = [];
        data.forEach((item) => {
            if (!isNaN(item.key)) {
                keyArr.push(item.key);
            } else {
                keyArr.push(parseInt(item.key));
            }
        });
        let maxNum = -1;
        if (keyArr.length > 0) {
            keyArr.sort((a, b) => parseInt(a) - parseInt(b));
            maxNum = parseInt(keyArr[keyArr.length - 1]);
        }
        let key = keyArr.length > 0 ? Number(maxNum) + 1 : 1;
        return key;
    };

    const appendSchool = (objName) => {
        let data = cloneDeep(getValues("schoolOption"));
        let key = getSchoolMaxKey(data[objName]);
        let curItem = {
            key: key,
            name: "",
            course: {},
        };
        data[objName].push(curItem);
        setValue("schoolOption", data);
        setSchoolOption(data);
    };

    const getCourseMaxKey = (data) => {
        let keyArr = [];
        let key = -1;
        if (JSON.stringify(data) != "{}") {
            keyArr = Object.keys(data).filter((item) => {
                if (!isNaN(Number(item))) {
                    return item;
                } else {
                    return parseInt(item);
                }
            });
            let maxNum = -1;
            if (keyArr.length > 0) {
                keyArr.sort((a, b) => parseInt(a) - parseInt(b));
                maxNum = parseInt(keyArr[keyArr.length - 1]);
            }
            key = keyArr.length > 0 ? Number(maxNum) + 1 : 1;
        }
        return key;
    };

    const appendCourse = (objName, paramItem) => {
        let data = cloneDeep(getValues("schoolOption"));
        data[objName].forEach((objItem) => {
            if (objItem.key == paramItem.key) {
                let curItem = ["", ""];
                let curKey = getCourseMaxKey(objItem.course);
                curKey = curKey == -1 ? 1 : curKey;
                objItem.course[Number(curKey)] = curItem;
            }
        });
        setValue("schoolOption", data);
        setSchoolOption(data);
    };

    const handleSubmitForm041Data = () => {
        let dataObj = cloneDeep(getValues("schoolOption"));

        let ccsObj = dataObj.CCSSchool;
        let ccwObj = dataObj.CCWSchool;

        for (let i = 0; i < ccsObj.length; i++) {
            let _index = -1;
            for (let k = 0; k < ccwObj.length; k++) {
                if (
                    ccwObj[k].name.trim().substring(3).trim() ==
                    ccsObj[i].name.trim().substring(3).trim()
                ) {
                    _index = k;
                    break;
                }
            }
            if (parseInt(_index) > 0) {
                let _key = -1;
                if (parseInt(ccsObj[i].key) > parseInt(ccwObj[_index].key)) {
                    _key = getSchoolMaxKey(ccsObj);
                } else if (
                    parseInt(ccsObj[i].key) < parseInt(ccwObj[_index].key)
                ) {
                    _key = getSchoolMaxKey(ccwObj);
                } else if (
                    ccsObj[i].key != ccwObj[_index].key &&
                    parseInt(ccsObj[i].key) == parseInt(ccwObj[_index].key)
                ) {
                    let ccsKey = getSchoolMaxKey(ccsObj);
                    let ccwKey = getSchoolMaxKey(ccwObj);
                    _key = ccsKey > ccwKey ? ccsKey : ccwKey;
                }
                if (ccsObj[i].key != ccwObj[_index].key) {
                    ccsObj[i].key = _key;
                    ccwObj[_index].key = _key;
                }
            }
        }

        for (let i = 0; i < ccsObj.length; i++) {
            for (let j = 0; j < ccwObj.length; j++) {
                if (ccsObj[i].key == ccwObj[j].key) {
                    // change school key
                    if (
                        !Object.is(
                            ccsObj[i].name.trim().substring(3).trim(),
                            ccwObj[j].name.trim().substring(3).trim()
                        ) &&
                        ccsObj[i].name != "" &&
                        ccwObj[j].name != ""
                    ) {
                        ccsObj[i].key = `${ccsObj[i].key}a`;
                        ccwObj[j].key = `${ccwObj[j].key}b`;
                    }
                    // change course key
                    if (
                        JSON.stringify(ccsObj[i].course) != "{}" &&
                        JSON.stringify(ccwObj[j].course) != "{}"
                    ) {
                        for (let k in ccsObj[i].course) {
                            let _index = -1;
                            for (let k2 in ccwObj[j].course) {
                                if (
                                    ccwObj[j].course[k2]
                                        .toString()
                                        .trim()
                                        .substring(3)
                                        .trim() ==
                                    ccsObj[i].course[k]
                                        .toString()
                                        .trim()
                                        .substring(3)
                                        .trim()
                                ) {
                                    _index = k2;
                                    break;
                                }
                            }

                            if (parseInt(_index) > 0) {
                                let _key = -1;
                                if (parseInt(k) > parseInt(_index)) {
                                    _key = getCourseMaxKey(ccsObj[i].course);
                                } else if (parseInt(k) < parseInt(_index)) {
                                    _key = getCourseMaxKey(ccwObj[j].course);
                                } else if (
                                    k != _index &&
                                    parseInt(k) == parseInt(_index)
                                ) {
                                    let ccsKey = getCourseMaxKey(
                                        ccsObj[i].course
                                    );
                                    let ccwKey = getCourseMaxKey(
                                        ccwObj[j].course
                                    );
                                    _key = ccsKey > ccwKey ? ccsKey : ccwKey;
                                }
                                if (k != _index) {
                                    let _item = ccsObj[i].course[k];
                                    delete ccsObj[i].course[k];
                                    ccsObj[i].course[_key] = _item;
                                    let _item2 = ccwObj[j].course[_index];
                                    delete ccwObj[j].course[_index];
                                    ccwObj[j].course[_key] = _item2;
                                }
                            }
                        }
                        for (let k in ccsObj[i].course) {
                            for (let k2 in ccwObj[j].course) {
                                if (k == k2) {
                                    if (
                                        !Object.is(
                                            ccsObj[i].course[k]
                                                .toString()
                                                .trim()
                                                .substring(3)
                                                .trim(),
                                            ccwObj[j].course[k2]
                                                .toString()
                                                .trim()
                                                .substring(3)
                                                .trim()
                                        )
                                    ) {
                                        let _item = ccsObj[i].course[k];
                                        delete ccsObj[i].course[k];
                                        ccsObj[i].course[`${k}a`] = _item;
                                        let _item2 = ccwObj[j].course[k2];
                                        delete ccwObj[j].course[k2];
                                        ccwObj[j].course[`${k}b`] = _item2;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        // console.log("dataObj----", dataObj);

        let curCcsCourse = {};
        let curCcsSchool = {};
        let curCcwCourse = {};
        let curCcwSchool = {};
        let curSubmitData = {};
        for (let [k, v] of Object.entries(dataObj)) {
            if (Array.isArray(v)) {
                if (k == "CCSSchool") {
                    for (let vDate of v) {
                        curCcsCourse[`${vDate.key}`] = vDate.course;
                        curCcsSchool[`${vDate.key}`] = vDate.name;
                    }
                } else if (k == "CCWSchool") {
                    for (let vDate of v) {
                        curCcwCourse[`${vDate.key}`] = vDate.course;
                        curCcwSchool[`${vDate.key}`] = vDate.name;
                    }
                }
            } else {
                curSubmitData[k] = v;
            }
        }

        curSubmitData.ccsCourseOption = JSON.stringify(curCcsCourse);
        curSubmitData.ccsSchoolOption = JSON.stringify(curCcsSchool);
        curSubmitData.ccwCourseOption = JSON.stringify(curCcwCourse);
        curSubmitData.ccwSchoolOption = JSON.stringify(curCcwSchool);
        return curSubmitData;
    };
    const handleSubmitForm101Data = (data) => {
        const paramObj = {};
        Object.entries(dataList.parameter).map((item) => {
            const itemValue = getValues(item[0]);
            if (item[0] === "job") {
                itemValue?.forEach((job) => {
                    job.subjectList = job?.subjectList?.filter((subject) =>
                        isNotEmpty(subject?.subjectName)
                    );
                });
            }
            if (handleParameter(item)) {
                paramObj[item[0]] = JSON.stringify(itemValue);
            } else {
                paramObj[item[0]] = `${itemValue}`;
            }
        });
        data[`parameter`] = paramObj;
        return paramObj;
    };

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.parameterPage")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main Box className={classes.main} style={{ width: 100 }}>
                    {formList != null &&
                    formList != undefined &&
                    selectedForm != 0 &&
                    !isObjEmpty(dataList) &&
                    !isObjEmpty(defaultValues) &&
                    getLayerPerForm() !== 0 ? (
                        <Box sx={{ pl: "15px" }}>
                            <Typography component="span" id="selected-form">
                                {t("common.portal.forForm")}&nbsp;
                            </Typography>
                            <Select
                                labelId="selected-form"
                                defaultValue={selectedForm}
                                style={{ textAlign: "end" }}
                                onChange={(e) => setForm(e.target.value)}
                                inputProps={{
                                    "aria-labelledby": "selected-form",
                                }}
                            >
                                {formList.map((element) => (
                                    <MenuItem value={element} key={element}>
                                        {element}
                                    </MenuItem>
                                ))}
                            </Select>
                            <Typography component="span">
                                {t("common.colon")}
                            </Typography>
                            <Typography>
                                {t(
                                    `form.Form${selectedForm
                                        .toString()
                                        .padStart(3, "0")}`,
                                    getFormTitleParam(
                                        selectedForm,
                                        formTitleParam,
                                        i18n.language
                                    )
                                )}
                            </Typography>
                            <br />
                            {selectedForm == "41" ? (
                                <span>
                                    <Link
                                        className={classes.cccLink}
                                        to={"/CCCUpdatePage"}
                                    >
                                        <Button
                                            style={{
                                                display: "block",
                                                marginLeft: "auto",
                                                marginRight: "0",
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            {t("CCCUpdatePage.updateCCCInfo")}
                                        </Button>
                                    </Link>
                                </span>
                            ) : (
                                ""
                            )}
                            <Typography
                                style={{ display: "inline-block" }}
                                variant="h6"
                                component="h1"
                            >
                                {t("common.portal.parametersOfThisForm")}
                            </Typography>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                {selectedForm === 100 ? (
                                    <ParameterTemplate100
                                        dataList={dataList}
                                        register={register}
                                        control={control}
                                        errors={errors}
                                        defaultValues={defaultValues}
                                        setValue={setValue}
                                        getValues={getValues}
                                        watch={watch}
                                    />
                                ) : selectedForm === 101 ? (
                                    <ParameterTemplate101
                                        dataList={dataList}
                                        register={register}
                                        control={control}
                                        errors={errors}
                                        defaultValues={defaultValues}
                                        setValue={setValue}
                                        getValues={getValues}
                                        watch={watch}
                                        trigger={trigger}
                                        reviewerList={reviewerList}
                                    />
                                ) : selectedForm === 102 ? (
                                    <ParameterTemplate102
                                        defaultValues={defaultValues}
                                        setValue={setValue}
                                    />
                                ) : selectedForm === 106 ? (
                                    <ParameterTemplate
                                        dataList={(() => {
                                            const priorityFields = [
                                                "year",
                                                "startDate",
                                                "endDate",
                                                "excludedScrnList",
                                                "trcNameOption",
                                            ];
                                            const sortedParameter = {};

                                            priorityFields.forEach((field) => {
                                                if (
                                                    dataList.parameter[
                                                        field
                                                    ] !== undefined
                                                ) {
                                                    sortedParameter[field] =
                                                        dataList.parameter[
                                                            field
                                                        ];
                                                }
                                            });

                                            Object.keys(
                                                dataList.parameter
                                            ).forEach((key) => {
                                                if (
                                                    !priorityFields.includes(
                                                        key
                                                    )
                                                ) {
                                                    sortedParameter[key] =
                                                        dataList.parameter[key];
                                                }
                                            });

                                            return {
                                                ...dataList,
                                                parameter: sortedParameter,
                                            };
                                        })()}
                                        schoolOption={schoolOption}
                                        selectedForm={selectedForm}
                                        register={register}
                                        control={control}
                                        removeSchool={removeSchool}
                                        removeCourse={removeCourse}
                                        appendCourse={appendCourse}
                                        appendSchool={appendSchool}
                                        removeParamer={removeParamer}
                                        appendParamer={appendParamer}
                                        errors={errors}
                                        defaultValues={defaultValues}
                                        setValue={setValue}
                                        getValues={getValues}
                                        trigger={trigger}
                                        schoolList={schoolList}
                                        i18n={i18n}
                                    />
                                ) : (
                                    <ParameterTemplate
                                        dataList={dataList}
                                        schoolOption={schoolOption}
                                        selectedForm={selectedForm}
                                        register={register}
                                        control={control}
                                        removeSchool={removeSchool}
                                        removeCourse={removeCourse}
                                        appendCourse={appendCourse}
                                        appendSchool={appendSchool}
                                        removeParamer={removeParamer}
                                        appendParamer={appendParamer}
                                        errors={errors}
                                        defaultValues={defaultValues}
                                        setValue={setValue}
                                    />
                                )}
                                <Typography variant="h6" component="h1">
                                    <br />
                                    {t("common.portal.messagesForReplySlip")}
                                </Typography>
                                <Paper style={{ padding: "20px" }}>
                                    <Typography
                                        style={{
                                            marginLeft: "40px",
                                            paddingTop: "15px",
                                            paddingBottom: "8px",
                                            position: "relative",
                                            right: "40px",
                                        }}
                                    >
                                        {t("common.portal.messages")}
                                    </Typography>
                                    <Box p={10}>
                                        <Box>
                                            {/* {replySlipFields.length === 0
                                        ? replySlipAppend({ value: "" })
                                        : null} */}
                                            {replySlipFields.map(
                                                (item, index) => (
                                                    <Box key={item.id}>
                                                        <InputLabel
                                                            htmlFor={`replySlipMsgs.${index}.value`}
                                                            style={{
                                                                display: "none",
                                                            }}
                                                        >
                                                            {t(
                                                                "common.portal.inputMessagesReplySlip"
                                                            )}
                                                        </InputLabel>
                                                        <CustomTextField
                                                            // error={errors?.[item[0]]}
                                                            inputProps={register(
                                                                `replySlipMsgs.${index}.value`
                                                            )}
                                                            placeholder={t(
                                                                "common.portal.inputMessagesReplySlip"
                                                            )}
                                                            control={control}
                                                            defaultValue={
                                                                item.value
                                                            }
                                                            style={{
                                                                width: "85%",
                                                            }}
                                                        />
                                                        <IconButton
                                                            onClick={() =>
                                                                replySlipRemove(
                                                                    index
                                                                )
                                                            }
                                                            color="primary"
                                                            aria-label="remove"
                                                        >
                                                            <RemoveCircleIcon />
                                                        </IconButton>
                                                    </Box>
                                                )
                                            )}
                                            <Button
                                                variant="contained"
                                                className="removeBtn"
                                                color="primary"
                                                onClick={() =>
                                                    replySlipAppend({
                                                        value: "",
                                                    })
                                                }
                                            >
                                                {t("common.button.append")}
                                            </Button>
                                        </Box>
                                    </Box>
                                </Paper>

                                <Typography variant="h6" component="h1">
                                    <br />
                                    {t("common.portal.emailTemplate")}
                                </Typography>
                                {emailContentFields.length != 0 ? (
                                    <EmailTemplate
                                        dataList={dataList}
                                        errors={
                                            errors?.finalEmailApplicantInfo
                                                ?.message
                                        }
                                        register={register}
                                        role={roles}
                                        allItem={emailContentFields}
                                        handleRadioChange={handleAllRadioChange}
                                        // urlLinkNRefNum={urlLinkNRefNum}
                                        control={control}
                                        watch={watch}
                                        selectedForm={selectedForm}
                                        formLayerNum={getLayerPerForm()}
                                    />
                                ) : null}

                                <Typography variant="h6" component="h1">
                                    <br />
                                    {t("common.portal.readOnlySetting")}
                                </Typography>
                                {selectedForm != 104 && (
                                    <Paper style={{ paddingLeft: "1.2rem" }}>
                                        <Box
                                            className={
                                                matches
                                                    ? classes.reminderBox
                                                    : classes.reminderBoxMobile
                                            }
                                        >
                                            <Grid
                                                container
                                                rowSpacing={1}
                                                columnSpacing={{
                                                    xs: 1,
                                                    sm: 2,
                                                    md: 3,
                                                }}
                                            >
                                                {getLayerPerForm() > 2 && (
                                                    <>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            style={{
                                                                alignSelf:
                                                                    "center",
                                                            }}
                                                        >
                                                            {selectedForm === 98
                                                                ? t(
                                                                      "common.portal.approver98"
                                                                  )
                                                                : t(
                                                                      "common.portal.approver"
                                                                  )}
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Controller
                                                                control={
                                                                    control
                                                                }
                                                                name={
                                                                    "readOnlyApprover"
                                                                }
                                                                defaultValue={
                                                                    defaultValues?.readOnlyApprover
                                                                }
                                                                render={({
                                                                    field,
                                                                }) => (
                                                                    <RadioGroup
                                                                        row
                                                                        aria-label={
                                                                            "readOnlyApprover"
                                                                        }
                                                                        value={
                                                                            field.value
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            field.onChange(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            );
                                                                            handleAllRadioChange(
                                                                                e,
                                                                                "readOnlyApprover"
                                                                            );
                                                                        }}
                                                                        defaultValue={
                                                                            defaultValues?.readOnlyApprover
                                                                        }
                                                                    >
                                                                        <FormControlLabel
                                                                            value="true"
                                                                            control={
                                                                                <Radio />
                                                                            }
                                                                            label={t(
                                                                                "common.portal.yes"
                                                                            )}
                                                                        />
                                                                        <FormControlLabel
                                                                            value="false"
                                                                            control={
                                                                                <Radio />
                                                                            }
                                                                            label={t(
                                                                                "common.portal.no"
                                                                            )}
                                                                        />
                                                                    </RadioGroup>
                                                                )}
                                                            />
                                                        </Grid>
                                                    </>
                                                )}

                                                {getLayerPerForm() > 3 ? (
                                                    <React.Fragment>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            style={{
                                                                alignSelf:
                                                                    "center",
                                                            }}
                                                        >
                                                            {selectedForm === 98
                                                                ? t(
                                                                      "common.portal.secondApprover98"
                                                                  )
                                                                : t(
                                                                      "common.portal.secondApprover"
                                                                  )}
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Controller
                                                                control={
                                                                    control
                                                                }
                                                                name={
                                                                    "readOnlySecondApprover"
                                                                }
                                                                defaultValue={
                                                                    defaultValues?.readOnlySecondApprover
                                                                }
                                                                render={({
                                                                    field,
                                                                }) => (
                                                                    <RadioGroup
                                                                        row
                                                                        aria-label={
                                                                            "readOnlySecondApprover"
                                                                        }
                                                                        value={
                                                                            field.value
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            field.onChange(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            );
                                                                            handleAllRadioChange(
                                                                                e,
                                                                                "readOnlySecondApprover"
                                                                            );
                                                                        }}
                                                                        defaultValue={
                                                                            defaultValues?.readOnlySecondApprover
                                                                        }
                                                                    >
                                                                        <FormControlLabel
                                                                            value="true"
                                                                            control={
                                                                                <Radio />
                                                                            }
                                                                            label={t(
                                                                                "common.portal.yes"
                                                                            )}
                                                                        />
                                                                        <FormControlLabel
                                                                            value="false"
                                                                            control={
                                                                                <Radio />
                                                                            }
                                                                            label={t(
                                                                                "common.portal.no"
                                                                            )}
                                                                        />
                                                                    </RadioGroup>
                                                                )}
                                                            />
                                                        </Grid>
                                                    </React.Fragment>
                                                ) : null}

                                                {getLayerPerForm() > 4 &&
                                                    selectedForm != 98 && (
                                                        <>
                                                            <Grid
                                                                item
                                                                xs={6}
                                                                style={{
                                                                    alignSelf:
                                                                        "center",
                                                                }}
                                                            >
                                                                {t(
                                                                    "common.portal.thirdApprover"
                                                                )}
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                {/* testing */}
                                                                <Controller
                                                                    control={
                                                                        control
                                                                    }
                                                                    name={
                                                                        "readOnlyThirdApprover"
                                                                    }
                                                                    defaultValue={
                                                                        defaultValues?.readOnlyThirdApprover
                                                                    }
                                                                    render={({
                                                                        field,
                                                                    }) => (
                                                                        <RadioGroup
                                                                            row
                                                                            aria-label={
                                                                                "readOnlyThirdApprover"
                                                                            }
                                                                            value={
                                                                                field.value
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) => {
                                                                                field.onChange(
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                );
                                                                                handleAllRadioChange(
                                                                                    e,
                                                                                    "readOnlyThirdApprover"
                                                                                );
                                                                            }}
                                                                            defaultValue={
                                                                                defaultValues?.readOnlyThirdApprover
                                                                            }
                                                                        >
                                                                            <FormControlLabel
                                                                                value="true"
                                                                                control={
                                                                                    <Radio />
                                                                                }
                                                                                label={t(
                                                                                    "common.portal.yes"
                                                                                )}
                                                                            />
                                                                            <FormControlLabel
                                                                                value="false"
                                                                                control={
                                                                                    <Radio />
                                                                                }
                                                                                label={t(
                                                                                    "common.portal.no"
                                                                                )}
                                                                            />
                                                                        </RadioGroup>
                                                                    )}
                                                                />
                                                            </Grid>
                                                        </>
                                                    )}

                                                {getLayerPerForm() > 5 && (
                                                    <>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            style={{
                                                                alignSelf:
                                                                    "center",
                                                            }}
                                                        >
                                                            {selectedForm === 98
                                                                ? t(
                                                                      "common.portal.fourthApprover98"
                                                                  )
                                                                : t(
                                                                      "common.portal.fourthApprover"
                                                                  )}
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            {/* testing */}
                                                            <Controller
                                                                control={
                                                                    control
                                                                }
                                                                name={
                                                                    "readOnlyFourthApprover"
                                                                }
                                                                defaultValue={
                                                                    defaultValues?.readOnlyFourthApprover
                                                                }
                                                                render={({
                                                                    field,
                                                                }) => (
                                                                    <RadioGroup
                                                                        row
                                                                        aria-label={
                                                                            "readOnlyFourthApprover"
                                                                        }
                                                                        value={
                                                                            field.value
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            field.onChange(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            );
                                                                            handleAllRadioChange(
                                                                                e,
                                                                                "readOnlyFourthApprover"
                                                                            );
                                                                        }}
                                                                        defaultValue={
                                                                            defaultValues?.readOnlyFourthApprover
                                                                        }
                                                                    >
                                                                        <FormControlLabel
                                                                            value="true"
                                                                            control={
                                                                                <Radio />
                                                                            }
                                                                            label={t(
                                                                                "common.portal.yes"
                                                                            )}
                                                                        />
                                                                        <FormControlLabel
                                                                            value="false"
                                                                            control={
                                                                                <Radio />
                                                                            }
                                                                            label={t(
                                                                                "common.portal.no"
                                                                            )}
                                                                        />
                                                                    </RadioGroup>
                                                                )}
                                                            />
                                                        </Grid>
                                                    </>
                                                )}

                                                <>
                                                    {/* <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                        alignSelf: "center",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.reviewer"
                                                    )}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Controller
                                                        control={control}
                                                        name={
                                                            "readOnlyEdbReviewer"
                                                        }
                                                        defaultValue={
                                                            defaultValues?.readOnlyEdbReviewer
                                                        }
                                                        render={({ field }) => (
                                                            <RadioGroup
                                                                row
                                                                aria-label={
                                                                    "readOnlyEdbReviewer"
                                                                }
                                                                value={
                                                                    field.value
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    field.onChange(
                                                                        e.target
                                                                            .value
                                                                    );
                                                                    handleAllRadioChange(
                                                                        e,
                                                                        "readOnlyEdbReviewer"
                                                                    );
                                                                }}
                                                                defaultValue={
                                                                    defaultValues?.readOnlyEdbReviewer
                                                                }
                                                            >
                                                                <FormControlLabel
                                                                    value="true"
                                                                    control={
                                                                        <Radio />
                                                                    }
                                                                    label={t(
                                                                        "common.portal.yes"
                                                                    )}
                                                                />
                                                                <FormControlLabel
                                                                    value="false"
                                                                    control={
                                                                        <Radio />
                                                                    }
                                                                    label={t(
                                                                        "common.portal.no"
                                                                    )}
                                                                />
                                                            </RadioGroup>
                                                        )}
                                                    />
                                                </Grid> */}
                                                </>
                                            </Grid>
                                        </Box>
                                    </Paper>
                                )}

                                <Typography variant="h6" component="h1">
                                    <br />
                                    {t("common.portal.reminder")}
                                </Typography>
                                <Paper style={{ paddingLeft: "1.2rem" }}>
                                    {/* <Box
                                        className={
                                            matches
                                                ? classes.reminderBox
                                                : classes.reminderBoxMobile
                                        }
                                    >
                                        <Typography
                                            component="span"
                                            style={{
                                                flex: 7,
                                                textIndent: "-1.2rem",
                                            }}
                                        >
                                            {t(
                                                "common.portal.completedSavedYears"
                                            )}
                                        </Typography>
                                        <InputLabel
                                            htmlFor="completedSavedYears"
                                            style={{
                                                display: "none",
                                            }}
                                        >
                                            {t(
                                                "common.portal.completedSavedYears"
                                            )}
                                        </InputLabel>
                                        <CustomTextField
                                            className={classes.disable}
                                            unit={t("common.portal.years")}
                                            component="span"
                                            style={{
                                                flex: 3,
                                            }}
                                            inputProps={register(
                                                "completedSavedYears",
                                                {
                                                    required:
                                                        t("errorMsg.required"),
                                                }
                                            )}
                                        ></CustomTextField>
                                    </Box> */}
                                    {/*    <Box
                                        className={
                                            matches
                                                ? classes.reminderBox
                                                : classes.reminderBoxMobile
                                        }
                                    >
                                        <Typography
                                            component="span"
                                            style={{
                                                flex: 6,
                                            }}
                                        >
                                            {t(
                                                "common.portal.completedSavedYearsNoti"
                                            )}
                                        </Typography>
                                        <InputLabel
                                            htmlFor="completedSavedYearsNoti"
                                            style={{
                                                display: "none",
                                            }}
                                        >
                                            {t(
                                                "common.portal.completedSavedYearsNoti"
                                            )}
                                        </InputLabel>
                                        <CustomTextField
                                            component="span"
                                            style={{
                                                flex: 1,
                                                marginTop: "0.2rem",
                                            }}
                                            inputProps={register(
                                                "completedSavedYearsNoti",
                                                {
                                                    required:
                                                        t("errorMsg.required"),
                                                }
                                            )}
                                        ></CustomTextField>
                                        <Box style={{ flex: 2 }}>
                                            <FormControl id="completedSavedYearsNotiChoice">
                                                <CustomSelect
                                                    style={{
                                                        width: "9rem",
                                                    }}
                                                    control={control}
                                                    defaultValue={
                                                        defaultValues?.completedSavedYearsNotiChoice
                                                    }
                                                    name="completedSavedYearsNotiChoice"
                                                    options={t(
                                                        "common.reminderOption",
                                                        {
                                                            returnObjects: true,
                                                        }
                                                    )}
                                                />
                                            </FormControl>
                                        </Box> */}
                                    {/* <Switch defaultChecked /> */}
                                    {/*  <Controller
                                            control={control}
                                            name={"hkYearReminderFlag"}
                                            defaultValue={
                                                defaultValues?.hkYearReminderFlag
                                            }
                                            render={({ field }) => (
                                                <>
                                                    <FormControlLabel
                                                        style={{
                                                            marginRight:
                                                                "-57px",
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={JSON.parse(
                                                                    field.value
                                                                )}
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    field.onChange(
                                                                        e.target
                                                                            .checked
                                                                    );
                                                                }}
                                                                inputProps={{
                                                                    "aria-label":
                                                                        "hkYearReminderFlag",
                                                                }}
                                                                color="success"
                                                                className={
                                                                    classes.switchSty
                                                                }
                                                                size="small"
                                                            />
                                                        }
                                                    />
                                                </>
                                            )}
                                        />
                                    </Box> */}

                                    <Box
                                        className={
                                            matches
                                                ? classes.reminderBox
                                                : classes.reminderBoxMobile
                                        }
                                    >
                                        <Typography
                                            component="span"
                                            style={{
                                                flex: 6,
                                                textIndent: "-1.2rem",
                                            }}
                                        >
                                            {t(
                                                "common.portal.receivedNotYetReviewed"
                                            )}
                                        </Typography>
                                        <InputLabel
                                            htmlFor="receivedPendingDays"
                                            style={{
                                                display: "none",
                                            }}
                                        >
                                            {t(
                                                "common.portal.receivedNotYetReviewed"
                                            )}
                                        </InputLabel>
                                        <CustomTextField
                                            component="span"
                                            style={{
                                                flex: 1,
                                                marginTop: "0.2rem",
                                            }}
                                            inputProps={register(
                                                "receivedPendingDays",
                                                {
                                                    required:
                                                        t("errorMsg.required"),
                                                }
                                            )}
                                        ></CustomTextField>
                                        <Box style={{ flex: 2 }}>
                                            <FormControl id="receivedPendingDaysChoice">
                                                <CustomSelect
                                                    style={{
                                                        width: "9rem",
                                                    }}
                                                    control={control}
                                                    defaultValue={
                                                        defaultValues?.receivedPendingDaysChoice
                                                    }
                                                    name="receivedPendingDaysChoice"
                                                    options={t(
                                                        "common.reminderOption",
                                                        {
                                                            returnObjects: true,
                                                        }
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                        {/* <Switch defaultChecked /> */}
                                        <Controller
                                            control={control}
                                            name={"actionReminderFlag"}
                                            defaultValue={
                                                defaultValues?.actionReminderFlag
                                            }
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    style={{
                                                        marginRight: "-57px",
                                                    }}
                                                    control={
                                                        <Switch
                                                            checked={JSON.parse(
                                                                field.value
                                                            )}
                                                            onChange={(e) => {
                                                                field.onChange(
                                                                    e.target
                                                                        .checked
                                                                );
                                                            }}
                                                            inputProps={{
                                                                "aria-label":
                                                                    "actionReminderFlag",
                                                            }}
                                                            color="success"
                                                            className={
                                                                classes.switchSty
                                                            }
                                                            size="small"
                                                        />
                                                    }
                                                />
                                            )}
                                        />
                                    </Box>

                                    <Box
                                        className={
                                            matches
                                                ? classes.reminderBox
                                                : classes.reminderBoxMobile
                                        }
                                    >
                                        <Typography
                                            component="span"
                                            style={{
                                                flex: 7,
                                                textIndent: "-1.2rem",
                                            }}
                                        >
                                            {t(
                                                "common.portal.analystReportFlag"
                                            )}
                                        </Typography>
                                        <Box style={{ flex: 3 }}>
                                            <Controller
                                                control={control}
                                                name={"analystReportFlag"}
                                                defaultValue={
                                                    defaultValues?.analystReportFlag
                                                }
                                                render={({ field }) => (
                                                    <>
                                                        <FormControlLabel
                                                            style={{
                                                                marginRight:
                                                                    "-57px",
                                                            }}
                                                            control={
                                                                <Switch
                                                                    checked={JSON.parse(
                                                                        field.value
                                                                    )}
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .checked
                                                                        );
                                                                    }}
                                                                    inputProps={{
                                                                        "aria-label":
                                                                            "analystReportFlag",
                                                                    }}
                                                                    color="success"
                                                                    className={
                                                                        classes.switchSty
                                                                    }
                                                                    size="small"
                                                                />
                                                            }
                                                        />
                                                    </>
                                                )}
                                            />
                                        </Box>
                                    </Box>

                                    <FormHelperText
                                        style={{ paddingLeft: "20px" }}
                                    >
                                        <ErrorMsg
                                            message={
                                                errors?.completedSavedYears
                                                    ?.message ||
                                                errors?.completedSavedYearsNoti
                                                    ?.message ||
                                                errors?.receivedPendingDays
                                                    ?.message
                                            }
                                        />
                                    </FormHelperText>
                                </Paper>

                                <FormBox>
                                    <Box
                                        display="flex"
                                        justifyContent="flex-end"
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                        >
                                            {t("common.portal.saveBlock")}
                                        </Button>
                                    </Box>
                                </FormBox>
                            </form>
                        </Box>
                    ) : null}
                </main>
            </Box>
            {isSavedOpen ? SavedDialog(isSavedOpen) : null}
            <AlertDialog
                formOpen={isDuplicatedMsg}
                content={t("common.portal.duplicatedReplySlip")}
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={differenceJobsDialog}
                content={
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: differenceJobsText,
                        }}
                    ></Typography>
                }
                confirmButton={{
                    action: () => {
                        const option = {
                            url: `${Config.CONTENT_PATH}/parameters/form`,
                            method: "POST",
                            body: JSON.stringify(differenceJobsSubmitData),
                        };
                        dispatch(send("SUBMIT_PARAMS", option))
                            .then((response) => response.json())
                            .then((result) => {
                                if (isObjectNotEmpty(result)) {
                                    setDifferenceJobsDialog(false);
                                    setIsSavedOpen(true);
                                } else {
                                    setSaveFail(true);
                                }
                            })
                            .catch((error) => {
                                console.log("fetch error: ", error);
                            });
                    },
                    label: t("common.confirm"),
                }}
                closeButton={{
                    action: () => setDifferenceJobsDialog(false),
                    label: t("common.cancel"),
                }}
            />
            <AlertDialog
                formOpen={saveFail}
                title={t("common.portal.savedFail")}
                content={t("common.portal.changesNotSaved")}
                confirmButton={{
                    action: () => {
                        setSaveFail(false);
                    },
                    label: t("common.reload.popup.confirm"),
                }}
            />
        </Container>
    );
}
export default ParameterPage;
